import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: `${BASE || ""}/api`, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    const url = cfg?.url || "";
    if (error.response?.status === 401 && !cfg._retry && !url.includes("/auth/")) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      try {
        await refreshing;
        return api(cfg);
      } catch (e) {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export function errorMessage(err) {
  const detail = err?.response?.data?.detail;
  if (!err?.response) return "Connexion impossible. Vérifiez votre réseau puis réessayez.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return "Certains champs sont invalides. Merci de les vérifier.";
  return "Une erreur est survenue. Merci de réessayer.";
}
